//
// starfield.js — boot shim. Resolves the site theme (themes/runtime.ts),
// boots the fx engine with that theme's weather, then applies the viewer's
// per-theme token overrides (themes/tokens.ts). After the sync boots, async
// hooks apply `?preset=` (visit-only) and signed-in roaming `principal.theme`
// when nothing else steers the look. This file only survives because every
// page already loads this URL.
//
import { bootTheme } from "./themes/runtime.js";
import { bootThemeTokens } from "./themes/tokens.js";
import { bootAlchemy } from "./alchemy/index.js";
import { bootPresetFromUrl, bootRoamingTheme } from "./presets.js";

bootTheme();
bootThemeTokens();
bootAlchemy();
void bootPresetFromUrl();
void bootRoamingTheme();
